import { TOGGLE_EQUIPMENT_INFO } from "../constants/actionTypes";

export default () => ({
  type: TOGGLE_EQUIPMENT_INFO
});
